import { createComponent } from '@lit-labs/react';
import React from 'react';
import { OmniIconElement } from 'omni-ui';

export const OmniIcon = createComponent(React, 'omni-icon', OmniIconElement);
